export const SaveQualificationsForm = (fields) => ({
  type: 'GET_QUALIFICATIONS_DATA',
  payload: { ...fields },
});

export const QualificationsFields = (fields) => {
  return ({
    type: 'GET_QUALIFICATIONS_VALUES',
    payload: { ...fields },
  });
};

export const ResetQualificationsCheckboxs = () => ({
  type: 'RESET_QUALIFICATIONS_DATA',
});

export default { SaveQualificationsForm, QualificationsFields };
